import React, { useState, useEffect } from 'react';
import './FormularioPadraoExpansivo.css';
import { MdExpandMore } from "react-icons/md";

const FormularioPadraoExpansivo = ({ 
    children, 
    tituloCard,
    tituloInterno,
    defaultExpanded = false
}) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    const [textVisible, setTextVisible] = useState(true);
    const [showText, setShowText] = useState(expanded ? "Mostrar menos" : "Mostrar mais");
    
    const toggleExpand = () => {
        setTextVisible(false);
        setTimeout(() => {
            setExpanded(!expanded);
            setShowText(!expanded ? "Mostrar menos" : "Mostrar mais");
            setTextVisible(true);
        }, 150);
    };

    useEffect(() => {
        setShowText(expanded ? "Mostrar menos" : "Mostrar mais");
    }, [expanded]);

    return (
      <div className="formulario-expansivo-container">
        <div className="formulario-expansivo-box">
          <div className="formulario-expansivo-cabecalho" onClick={toggleExpand}>
            {tituloCard && <h2 className="titulo-formulario-expansivo">{tituloCard}</h2>}
            <div className="acoes-expansao">
              <span className={`texto-expansao ${textVisible ? 'visible' : 'hidden'}`}>
                {showText}
              </span>
              <div className={`seta-expansao ${expanded ? 'expandido' : ''}`}>
                <MdExpandMore />
              </div>
            </div>
          </div>

          <div className={`formulario-expansivo-wrapper ${expanded ? 'expandido' : ''}`}>
            <hr className="divisor-titulo-formulario-expansivo" />
            <h4 className="texto-interno-formulario-expansivo">{tituloInterno}</h4>
            <div className="formulario-expansivo-content">
              {children}
            </div>
          </div>
        </div>
      </div>
    );
}
 
export default FormularioPadraoExpansivo;